import { DataSource, HorizontalSpacer, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrailerPool extends Layout {
    horizontalspacer2: HorizontalSpacer;
    panelActive: Panel;
    panelControls: Panel;
    sourceLocation: DataSource;
    sourceTrailerPool: DataSource;
    switchActive: Switch;
    switchIncludeInProg: Switch;
    tableTrailers: Table;
    textboxAvgIdle: Textbox;
    textboxBalance: Textbox;
    textboxTotalTrailers: Textbox;
    textboxTrailerPoolMin: Textbox;
    textboxTrailerPoolRadius: Textbox;
    textboxTrailerPoolSize: Textbox;
}
